import { ActivityVerb } from "./ActivityLog";

export type PlacementActivityChange = {
  id: string;
  displayName: string;
  idType?: IdType;
  updatedAt: string;
  surfaceType: string;
};

export type PlacementActivityCardProps = {
  commonActivityProps: any;
  placement: PlacementActivityChange;
  verb: ActivityVerb;
};

export enum SurfaceType {
  Sheet = "sheet",
  Document = "document",
}

export enum IdType {
  SheetId = "sheetId",
  DocumentId = "documentId",
  LineageUrn = "lineageUrn",
}

export enum PlacementType {
  None,
  SheetView,
  TwoDFileView,
  ThreeDFileView,
}
